<script lang="ts">
  import { StringUtils } from "$lib/stringUtils";
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
  import { ListCollapse , Euro, FolderOpen , Images } from "lucide-svelte";
  import { getContext, onMount } from "svelte";
  import { location, params } from "svelte-spa-router";
  import TopmenuNav from "./topmenu-nav.svelte";
  import AppBreadcrumb from "./app-breadcrumb.svelte";
  import MainTemplate from "$src/presentation/main/main-template.svelte";
  import BottommenuNav from "./bottommenu-nav.svelte";
  import type { NavItem } from "./NavItems";
  import ConnectedUserList from "$src/presentation/main/components/connected-user-list.svelte";
  import type { GroupStoreInfo } from "$src/domain/users/UserGroupStoreAccess";
  import { DraftingCompass } from 'lucide-svelte';
  import { isEditActive } from "$src/application/main/mainTemplateStore";

  let { activeGroupStore }: AuthContext = getContext(ContextTokens.Auth);
  export let isEmbedded: boolean;

  let projectId: number;

  let navItems: NavItem[] = [];

  onMount(() => extractParams($params, $activeGroupStore));

  $: extractParams($params, $activeGroupStore);

  function extractParams(parameters?: Record<string, string>, gsInfo?: GroupStoreInfo ) {
    projectId = StringUtils.getNumberOrDefault(parameters?.projectId, 0);

    navItems = [
      {
        title: "Détails",
        href: `#/gs/${gsInfo?.groupStoreId}/projects/${projectId}`,
        acceptParams: false,
        icon: ListCollapse ,
      },
      {
        title: "Plan",
        href: `#/gs/${gsInfo?.groupStoreId}/projects/${projectId}/cad`,
        acceptParams: false,
        icon: DraftingCompass,
      },
      {
        title: "Factures",
        href: `#/gs/${gsInfo?.groupStoreId}/projects/${projectId}/invoices`,
        acceptParams: true,
        icon: Euro,
      },
      {
        title: "Documents",
        href: `#/gs/${gsInfo?.groupStoreId}/projects/${projectId}/documents`,
        acceptParams: true,
        icon: FolderOpen ,
      },
      {
        title: "Photos",
        href: `#/gs/${gsInfo?.groupStoreId}/projects/${projectId}/pictures`,
        acceptParams: true,
        icon: Images,
      },
    ];
  }

  function isActiveLocation(currentLocation: string, item: NavItem): boolean {
    let cleanHref = item.href.replace(/^#/, "");
    const cleanCurrentLocation = currentLocation.endsWith("/")
      ? currentLocation.slice(0, -1)
      : currentLocation;

    if (item.acceptParams) return cleanCurrentLocation.startsWith(cleanHref);

    return cleanCurrentLocation === cleanHref;
  }
</script>

{#if $activeGroupStore?.groupStoreId}
  <MainTemplate {isEmbedded}>
      <div slot="menu-top-left">
        <AppBreadcrumb groupStoreId={$activeGroupStore.groupStoreId} />
      </div>
      <div slot="menu-top-center">
        <TopmenuNav items={navItems} {isActiveLocation} />
      </div>
      <div slot="menu-top-right" class="flex-shrink flex flex-row gap-2 h-6 justify-center items-center">
        <slot name="menu-top-right-action" />
        <ConnectedUserList />
      </div>

    <slot />


    <div slot="menu-info-bottom">
      <slot name="menu-info-bottom" />
    </div>
    <div slot="menu-action-bottom">
      <slot name="menu-action-bottom" />
    </div>
    <div slot="menu-bottom">
      <BottommenuNav items={navItems} {isActiveLocation} />
    </div>
  </MainTemplate>
{/if}
